import styled from 'styled-components';

// Styled components
const ConfirmationContainer = styled.div`
    padding: 20px;
    text-align: center;
    background-color: #f9f9f9;
    border-radius: 10px;
    margin: auto;
    margin-top: 20px;
`;

const ConfirmationTitle = styled.h1`
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #333;
`;

const ConfirmationMessage = styled.p`
    color: #555555;
    font-size: 16px;
    margin-top: 15px;
`;

// SchedulerConfirmation component
const SchedulerConfirmation = () => {
  return (
    <>
      { /* @ts-ignore */}
      <ConfirmationContainer>
        <ConfirmationTitle>Meeting Confirmed</ConfirmationTitle>
        <ConfirmationMessage>
          Your meeting is scheduled! You will receive an email shortly with all the necessary
          instructions and details. Please check your inbox for this information.
        </ConfirmationMessage>
      </ConfirmationContainer>
    </>
  );
};

export default SchedulerConfirmation;
